import { createCoreError } from "../errors/coreError.js";

export const PROJECT_FILE_VERSION = 1;

function readJsonInput(json) {
  if (typeof json === "string") {
    return JSON.parse(json);
  }
  if (json && typeof json === "object") {
    return json;
  }
  throw createCoreError("core.errors.invalidProjectFile");
}

function isProjectShape(value) {
  return Boolean(
    value &&
    typeof value === "object" &&
    Array.isArray(value.projects),
  );
}

export function buildProjectFilePayload(project, layout) {
  return {
    app: "Plaatplan",
    version: PROJECT_FILE_VERSION,
    exportedAt: new Date().toISOString(),
    project,
    layout: {
      sheets: layout.sheets.map(({ index, thickness, thicknessSheetIndex, placements }) => ({
        index,
        thickness,
        thicknessSheetIndex,
        placements,
      })),
      metrics: layout.metrics,
      breakdown: layout.breakdown,
    },
  };
}

export function serializeProjectFilePayload(payload) {
  return JSON.stringify(payload, null, 2);
}

/**
 * Parse a Plaatplan project file (JSON string or object).
 * Expects the export wrapper from `buildProjectFilePayload`.
 *
 * @returns {{ project: object, layout: object | null, version: number, exportedAt: string | null }}
 */
export function parseProjectFile(json) {
  const data = readJsonInput(json);

  if (!data || typeof data !== "object") {
    throw createCoreError("core.errors.invalidProjectFile");
  }

  if (data.version != null && data.version !== PROJECT_FILE_VERSION) {
    throw createCoreError("core.errors.unsupportedProjectVersion", { version: data.version });
  }

  if (!data.project || !isProjectShape(data.project)) {
    throw createCoreError("core.errors.missingProjectData");
  }

  return {
    project: data.project,
    layout: data.layout ?? null,
    version: PROJECT_FILE_VERSION,
    exportedAt: data.exportedAt ?? null,
  };
}
